/** Directory of the SDK script (dwtf.global.js / dwtf.push.js / dwtf.qr.js). */
export function sdkDir(): string {
  try {
    const scripts = document.getElementsByTagName("script");
    for (let i = scripts.length - 1; i >= 0; i--) {
      const src = scripts[i]?.src;
      if (src && /dwtf\.(global|push|qr|analytics|rank|support)\.js(\?|#|$)/.test(src)) {
        return src.replace(/[^/]+(\?.*)?(#.*)?$/, "");
      }
    }
  } catch {
    /* ignore */
  }
  return "https://dev.d.wtf/";
}

export function sdkAssetUrl(rel: string): string {
  return sdkDir() + rel.replace(/^\//, "");
}
